export const handleBulkActionChange = (target) => {
    const actions = target.closest?.('od-select[data-bulk-actions]');

    if (!actions || target.value === '') {
        return;
    }

    const trigger = actions
        .closest('.action-bar')
        ?.querySelector(`[data-bulk-action="${target.value}"]`);

    actions.clear();

    trigger?.click();
};
